import { Component, OnInit, Input } from '@angular/core';
import * as L from "leaflet";
import { PhameeService } from '../../../services/phamee.service';

@Component({
  selector: 'smart-leaflet-map',
  templateUrl: './leaflet-map.component.html',
  styleUrls: ['./leaflet-map.component.scss']
})
export class LeafletMapComponent implements OnInit {
  map: L.Map;
  map_focus: L.Map;
  polygon;
  marker;
  drawPluginOptions;

  numberOfSensor = [];
  numberOfLatLong = [];
  centerpoint = [];

  count_sensor1 = 0;
  count_sensor2 = 0;
  marker_basket1 = [];
  marker_basket2 = [];
  datenow: any;

  show_button = false;
  change_page = false;

  @Input()
  plotId: string;
  constructor(
    private phameeService: PhameeService,
  ) { }

  ngOnInit(): void {
    this.getPlotforMap()
    console.log("plotId !!!!!!!!!! ", this.plotId)
  }
  getPlotforMap() {
    console.log("getPlotforMap : ")
    this.phameeService.getPlotbyPlotId(this.plotId)
      .subscribe(async success => {
        console.log("getPlotforMap !@!!!! success : ", success)
        if (success.code == 200) {
          let data = success.data;
          console.log("data : ", data)

          let polygonDetail = {
            coordinates : data[0].coordinates,
            zone : {
              color : data[0].zone.color,
              name : data[0].zone.name
            }
          }
          this.getMap(polygonDetail)

          // data.forEach(element => {
          //   this.BreedTypeList.push({
          //     name: element.name,
          //     value: element._id
          //   })
          // });
        }
      });
  }
  getMap(polygon): void {
    console.log("polygon : ", polygon)
    this.numberOfLatLong = [];
    // if (this.map) {
    //   this.map.remove();
    //   this.map = null;
    // }
    this.map = L.map('map', { zoomControl: false }).setView([polygon.coordinates.center.lat, polygon.coordinates.center.lon], polygon.coordinates.center.zoom_lv);
    L.control.zoom({ position: 'topright' }).addTo(this.map);
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
      .addTo(this.map);
    for (let lt = 0; lt < polygon.coordinates.map_polygon.length; lt++) {
      this.numberOfLatLong[lt] = [polygon.coordinates.map_polygon[lt].lat, polygon.coordinates.map_polygon[lt].lon];
    }
    let latlong = this.numberOfLatLong;
    console.log("latlong ::: ", latlong)
    this.polygon = L.polygon(
      [
        [latlong],
      ],
      {
        color: polygon.zone.color,
        fillColor: '#ffffff',
        fillOpacity: 0.2,

      },
    ).addTo(this.map);
    this.polygon.bindPopup(polygon.zone.name);   
  }

}
